import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('click', $event)),
    style: _normalizeStyle($options.getComputedStyle),
    class: "skeleton-item"
  }, [_createElementVNode("div", null, _toDisplayString($props.text), 1)], 4);
}